import { C, sans, type, space } from "../theme.ts";

/** A plain sentence where a list would otherwise be — nothing found yet, or
 * nothing to find. No icon, no illustration: a fact, stated once. */
export function EmptyState({ children }: { children: React.ReactNode }) {
  return <p style={{ fontFamily: sans, fontSize: type.body, color: C.inkFaint, margin: `${space.lg}px 0 0` }}>{children}</p>;
}
